<template>
  <div>
    <h1>REDCap Closure Submitter Detail</h1>


    <div class="row">
      <div class="col-sm">

        <b-link href="/redcap" style="display:block; margin-bottom:20px;">Return to REDCap Submitter List</b-link>

      </div>
    </div>

    <div class="row">
      <div class="col-sm">

        <template v-for="event in events">
          <b-card style="margin-bottom:10px;">

            <div slot="header" class="mb-0"><strong>{{cardTitle(event)}}</strong></div>

            <template v-for="error in event.errors">
              <b-list-group>
                <b-list-group-item href="#" style="margin-bottom:5px;">
                  <div>
                    <table>
                      <tr>
                        <td style="width:150px;"><strong>Context</strong></td>
                        <td>{{error.context}}</td>
                      </tr>
                      <tr>
                        <td><strong>Attribute</strong></td>
                        <td>{{error.attribute}}</td>
                      </tr>
                      <tr>
                        <td><strong>Messsage</strong></td>
                        <td>{{error.message}}</td>
                      </tr>
                    </table>
                  </div>
                </b-list-group-item>

              </b-list-group>
            </template>

          </b-card>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 3 });

export default {
  props: [
    'id'
  ],
  title:  'REDCap Closure Submitter Detail',
  data: () => ({
    isBusy: false,
    fields: [
      {key: 'dataAccessGroupId', sortable: false, label: 'DAG'},
      {key: 'name', sortable: false, label: 'Submitter Name'},
      {key: 'providerName', sortable: false, label: 'Provider Name'},
      {key: 'healthStatus', sortable: false, label: 'Status'},
      {key: 'errorCount', sortable: false, label: 'Errors'},
      {key: 'lastSubmissionDate', sortable: false, label: 'Last Submission'},
      {key: 'actions', label: 'Actions'}
    ],
    events: [],
    options: {
      format: 'YYYY-MM-DD',
      useCurrent: false,
    }
  }),

  created () {
    this.initialize()
  },

  methods: {

    fetchClosureEvents() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/redcap/closureErrors/${this.id}`)
          .then(response => {
            console.log(response.data.events)
            this.events = response.data.events
            this.isBusy = false
          })
    },
    initialize () {
      this.isBusy = true
      this.fetchClosureEvents()
    },

    cardTitle(e) {
      return e.context + ': ' + e.eventDateTime + '  Record Id: ' + e.recordId + ' Visit #: ' + e.visitId
    }

  }
}
</script>